module.exports = __webpack_public_path__ + "static/media/avatar-denisse.45bcb758.png";